import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["field", "showIcon", "hideIcon"];

  connect() {
    // Ensure we have the input field
    if (!this.fieldTarget) {
      const fieldId = this.element.dataset.field;
      this.fieldTarget = document.getElementById(fieldId);
    }
  }

  toggle() {
    // Toggle the password field type
    const type =
      this.fieldTarget.getAttribute("type") === "password"
        ? "text"
        : "password";
    this.fieldTarget.setAttribute("type", type);

    // Toggle the icons
    if (this.hasShowIconTarget && this.hasHideIconTarget) {
      this.showIconTarget.classList.toggle("hidden");
      this.hideIconTarget.classList.toggle("hidden");
    }
  }
}
